module.exports = __webpack_public_path__ + "media/images/emblems/Nuglar-StPantaleon-blason-11893859574b229fa2cb341c156545c1.png";